import { lazy } from "react";

const AILogs = lazy(() => import("./ai-logs"));
const NotFound = lazy(() => import("./not-found"));
const Posts = lazy(() => import("./posts"));
const Main = lazy(() => import("./main"));
const UserDetails = lazy(() => import("./user-details"));
const ContentGenerationFeedbacks = lazy(() => import("./content-generation-feedbacks"));
const CodeRedemptions = lazy(() => import("./code-redemptions"));
const WorkspaceDetails = lazy(() => import("./workspace-details"));
const TransferAdminRights = lazy(() => import("./transfer-admin-rights"));
const Refund = lazy(() => import("./refund"));
const Supergrow2Whitelist = lazy(() => import("./supergrow-2-whitelist"));
const CreateApiKey = lazy(() => import("./create-api-key"));

export {
  AILogs,
  NotFound,
  Posts,
  Main,
  UserDetails,
  ContentGenerationFeedbacks,
  CodeRedemptions,
  WorkspaceDetails,
  TransferAdminRights,
  Refund,
  Supergrow2Whitelist,
  CreateApiKey,
};
